export const paymentData = [
    {
        id:'1',
        name:'Watson',
        paymentMethod:'Bank',
        accountNo:'12123123',
        date:'12/12/2025'
    },
    {
        id:'2',
        name:'Sarah',
        paymentMethod:'Bank',
        accountNo:'12345678',
        date:'12/12/2025'
    },
    {
        id:'3',
        name:'Zahid',
        paymentMethod:'Bank',
        accountNo:'12123123',
        date:'12/12/2025'
    }
]